import styled from "@emotion/styled"
import SectionWrapper from "../../components/section-wrapper/section-wrapper.component"
import { Container, Typography } from "@mui/material"
import CustomImage from "../../components/custom-image/custom-image.component"

export const Section = styled(SectionWrapper)`
  border-radius: 32px 32px 40px 40px;
  background: var(
    --Linear,
    linear-gradient(90deg, #006e56 0.23%, #00a179 61.82%)
  );
  padding-bottom: 0;
  overflow: hidden;
`

export const Wrapper = styled(Container)``

export const TopContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const Title = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.light};
  text-align: center;
  font-size: ${({ theme }) => theme.typography.pxToRem(56)};
  font-style: normal;
  font-weight: 550;
  line-height: ${({ theme }) => theme.typography.pxToRem(64)};
  max-width: 879px;
  margin-bottom: ${({ theme }) => theme.typography.pxToRem(36)};

  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: ${({ theme }) => theme.typography.pxToRem(32)};
    line-height: ${({ theme }) => theme.typography.pxToRem(40)};
    font-weight: 500;
    margin-bottom: ${({ theme }) => theme.typography.pxToRem(24)};
    letter-spacing: -0.32px;
  }
`

export const Description = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.light};
  text-align: center;
  font-size: ${({ theme }) => theme.typography.pxToRem(18)};
  font-style: normal;
  font-weight: 400;
  line-height: ${({ theme }) => theme.typography.pxToRem(28)};
  letter-spacing: -0.036px;
  opacity: 0.8;
  max-width: 637px;

  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: ${({ theme }) => theme.typography.pxToRem(16)};
    line-height: ${({ theme }) => theme.typography.pxToRem(22)};
  }
`

export const CheckContainer = styled.div`
  border-radius: 31px;
  border: 1px solid ${({ theme }) => theme.palette.primary.light};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.3rem;
  margin-top: ${({ theme }) => theme.typography.pxToRem(32)};
  gap: 0.5rem;

  p {
    text-align: center;
    font-size: ${({ theme }) => theme.typography.pxToRem(16)};
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
`

export const TabsContainer = styled.div`
  margin-top: ${({ theme }) => theme.typography.pxToRem(112)};
  /* display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center; */
  .MuiButtonBase-root {
    color: ${({ theme }) => theme.palette.primary.light} !important;
    text-transform: capitalize;
    font-size: ${({ theme }) => theme.typography.pxToRem(22)};
    font-weight: 600;
    line-height: ${({ theme }) => theme.typography.pxToRem(30)};
    ${({ theme }) => theme.breakpoints.up("md")} {
      width: 180px;
    }
  }

  .MuiTabs-indicator {
    background-color: ${({ theme }) => theme.palette.primary.light};
  }

  /* .MuiTabs-scroller {
    width: 540px;
  } */

  .MuiBox-root {
    border-bottom: 2px solid rgba(103, 198, 175, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;

    ${({ theme }) => theme.breakpoints.up("md")} {
      width: 540px;
    }
  }
  .MuiTabPanel-root {
    padding: 0;
    padding-bottom: ${({ theme }) => theme.typography.pxToRem("60")};
  }
`

export const FeatureDescriptionContainer = styled.div`
  /* margin-top: ${({ theme }) => theme.typography.pxToRem(120)}; */
  /* position: relative; */
`

export const Feature = styled.div`
  margin-bottom: ${({ theme }) => theme.typography.pxToRem(24)};
  display: flex;
  gap: 0.5rem;

  ${({ theme }) => theme.breakpoints.up("md")} {
    max-width: 403px;
  }
`

export const FeatureTitle = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.light};
  font-size: ${({ theme }) => theme.typography.pxToRem(20)};
  font-style: normal;
  font-weight: 600;
  line-height: ${({ theme }) => theme.typography.pxToRem(28)};
  width: 100%;

  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: ${({ theme }) => theme.typography.pxToRem(18)};
    line-height: ${({ theme }) => theme.typography.pxToRem(24)};
  }
`

export const FeatureDescription = styled(Typography)`
  color: #fbfbff;
  font-size: ${({ theme }) => theme.typography.pxToRem(17)};
  font-style: normal;
  font-weight: 400;
  line-height: ${({ theme }) => theme.typography.pxToRem(24)};
  opacity: 0.7;
  width: 100%;

  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: ${({ theme }) => theme.typography.pxToRem(16)};
    line-height: ${({ theme }) => theme.typography.pxToRem(22)};
  }
`

export const SvgContainer = styled.div`
  width: 10%;
  display: flex;
  justify-content: center;
  padding-top: 0.5rem;
`

export const InfoContainer = styled.div`
  width: 90%;
`

export const ImageContainer = styled.div`
  position: relative;

  &.insightful {
    right: 0;
    ${({ theme }) => theme.breakpoints.up("sm")} {
      right: -10%;
    }
    ${({ theme }) => theme.breakpoints.up("md")} {
      right: 0;
    }
  }

  &.easy {
    right: -200px;
    bottom: -105px;
    margin-top: -120px;
    ${({ theme }) => theme.breakpoints.down("md")} {
      bottom: -90px;
      right: -100px;
    }
  }
`

export const Image = styled(CustomImage)`
  /* position: absolute; */
  /* right: 0; */

  &.insightful {
    // width: 136%;
    // ${({ theme }) => theme.breakpoints.up("sm")} {
    //   width: 100%;
    // }
    // ${({ theme }) => theme.breakpoints.up("md")} {
    //   width: 134%;
    // }
  }

  &.easy {
    width: 397.378px;
    height: 830.21px;
    img {
      width: 397.378px;
      height: 830.21px;
      object-fit: contain !important;
    }

    ${({ theme }) => theme.breakpoints.down("md")} {
      width: 228.998px;
      height: 478.359px;
      img {
        width: 228.998px;
        height: 478.359px;
      }
    }
  }

  &.notification {
    position: absolute;
    top: 180px;
    left: -200px;
    width: 291px;

    img {
      width: 291px;
      object-fit: contain !important;
    }
    ${({ theme }) => theme.breakpoints.down("md")} {
      width: 182px;
      top: 100px;
      left: -100px;
      img {
        width: 182px;
        object-fit: contain !important;
      }
    }
  }
`

export const TabListContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 4rem;
`
